import { GET_AVERAGE_OBS_BY_LAT_LONG } from '../actions/averageObsActions';

import { LOCATION_CHANGED } from '../actions/locationActions';

const initialState = {
    averageObsIsRefreshing: false
};

export function averageObs(state = initialState, action) {
    switch (action.type) {
        case LOCATION_CHANGED:
        {
            return initialState;
        }

        case GET_AVERAGE_OBS_BY_LAT_LONG.pending:
        {
            return {
                ...state,
                averageObs: undefined,
                averageObsIsRefreshing: true
            };
        }

        case GET_AVERAGE_OBS_BY_LAT_LONG.fulfilled:
        {
            return {
                ...state,
                averageObs: action.payload,
                lastError: undefined,
                averageObsIsRefreshing: false
            };
        }

        case GET_AVERAGE_OBS_BY_LAT_LONG.rejected:
        {
            return {
                ...state,
                averageObs: undefined,
                lastError: action.payload,
                averageObsIsRefreshing: false
            };
        }
        default:
        {
            return state;
        }
    }
}
